export const siteName = 'Start or Sit Rep';

export const defaultTitle = 'Start or Sit Rep – NFL Injury Predictions';

export const defaultDescription =
  'Up-to-date NFL player availability predictions derived from news and data. Track injuries and odds for weekly and season outcomes.';

export const defaultOgImage = '/football.svg';

export function buildCanonical(pathname?: string): string {
  const { origin, pathname: currentPathname } = window.location;
  const path = pathname ?? currentPathname;
  return `${origin}${path}`;
}

export function buildBreadcrumbJsonLd(items: Array<{ name: string; url: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}


